<template>
  <el-drawer v-model="visible" custom-class="pro-drawer" size="30%" :close-on-click-modal="false" destroy-on-close>
    <template #title>
      <h4>{{ title }}</h4>
    </template>
    <el-form ref="proAddOrEditFormRef" label-position="right" label-width="120px" :model="proAddOrEditForm" :rules="rules">
      <el-form-item :label="proAddOrEditForm.pid ? '工区(分部):' : '项目名称:'" prop="projectName">
        <el-input v-model="proAddOrEditForm.projectName"></el-input>
      </el-form-item>
      <el-form-item v-if="proAddOrEditForm.pid" label="分包单位名称:" prop="subcontractorName">
        <el-input v-model="proAddOrEditForm.subcontractorName"></el-input>
      </el-form-item>
      <el-form-item v-if="!proAddOrEditForm.pid" label="项目编号:" prop="projectNum">
        <el-input v-model="proAddOrEditForm.projectNum"></el-input>
      </el-form-item>
      <el-form-item :label="proAddOrEditForm.pid ? '简称:': '项目简称:'" prop="projectShortName">
        <el-input v-model="proAddOrEditForm.projectShortName"></el-input>
      </el-form-item>
      <el-form-item v-if="!proAddOrEditForm.pid" label="项目状态:" prop="statusNum">
        <el-select v-model="proAddOrEditForm.statusNum" @change="statusChange" placeholder="项目状态">
          <el-option label="未完工" value="0"></el-option>
          <el-option label="已完工" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!proAddOrEditForm.pid" label="项目开始时间:">
        <el-date-picker v-model="proAddOrEditForm.startUpTime" value-format="YYYY-MM-DD" type="date" placeholder="项目开始时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="!proAddOrEditForm.pid" label="预计结束时间:">
        <el-date-picker v-model="proAddOrEditForm.planCompleteTime" type="date" value-format="YYYY-MM-DD" placeholder="预计结束时间">
        </el-date-picker>
      </el-form-item>
      <template v-if="projectListRowData">
        <el-form-item label="负责人:">
          <el-select v-model="proAddOrEditForm.directorId" clearable @change="directorUserChange">
            <el-option value="" label=""></el-option>
            <el-option v-for="u of users" :key="u.id" :value="u.id" :label="u.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人电话:">
          <el-input v-model="proAddOrEditForm.directorPhone" disabled></el-input>
        </el-form-item>
        <el-form-item v-if="!proAddOrEditForm.pid" label="项目联系人:">
          <el-select v-model="proAddOrEditForm.contactsId" clearable @change="contactsUserChange">
            <el-option v-for="u of users" :key="u.id" :value="u.id" :label="u.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!proAddOrEditForm.pid" label="联系人电话:">
          <el-input v-model="proAddOrEditForm.contactsPhone" disabled></el-input>
        </el-form-item>
      </template>
      
      <el-form-item :label="proAddOrEditForm.pid ? '分包介绍:' : '项目介绍:'">
        <el-input v-model="proAddOrEditForm.projectIntroduce" :rows="3" type="textarea" :placeholder="proAddOrEditForm.pid ? '分包介绍:' : '项目介绍:'" />
      </el-form-item>
      <el-form-item label="电子围栏:">
        <el-button type="primary" icon="share" @click="innerElectronicDenceDrawer=true" circle></el-button>
        <div v-if="proAddOrEditForm.electronicFence" style="width: 100%;height: 200px;">
          <MapShowView :electronicFence="proAddOrEditForm.electronicFence"      />
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <div style="flex: auto">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="save">提交</el-button>
      </div>
    </template>

    <!-- 电子围栏 -->
    <el-drawer
        v-model="innerElectronicDenceDrawer"
        title="电子围栏"
        size="100%"
        custom-class="electronic-dence-drawer"
    >
        <MapView  :electronicFence="proAddOrEditForm.electronicFence"   :drawComplete="drawComplete"    />
    </el-drawer>

  </el-drawer>
</template>
<script>
import { defineComponent } from "vue";
import { getProjectDirectUser, saveProject } from "@/api/proman/project";
import { ElMessage } from "element-plus";
import { deepClone } from "@/utils/common";
import MapView from './Map.vue'
import MapShowView from './MapShow.vue'
export default defineComponent({
  components:{MapView,MapShowView},
  emits: ["update:modelValue", "scarch"],
  data() {
    return {
      users: [],
      proAddOrEditForm: {
        statusNum:'0',
        electronicFence:''
      },
      rules: {
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "change" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "change",
          },
        ],
        projectNum: [
          { required: true, message: "请输入项目编号", trigger: "change" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "change",
          },
        ],
        projectShortName: [
          { required: true, message: "请输入项目简称", trigger: "change" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "change",
          },
        ],
        statusNum: [
          { required: true, message: "请输选择项目状态", trigger: "change" },
        ],
        subcontractorName: [{required: true, message: '分包单位名称不能为空'}]
      },

      //是否打开电子围栏绘制
      innerElectronicDenceDrawer:false,
    };
  },
  props: {
    modelValue: Boolean,
    title: String,
    projectListRowData: Object,
    childProjectListRowData: Object,
  },
  watch: {
    visible(val) {
      if (!val) {
        return;
      }
      this.users = [];
      if (this.projectListRowData) { // 修改
        this.proAddOrEditForm = deepClone(this.projectListRowData);
        this.proAddOrEditForm.statusNum = this.proAddOrEditForm.statusNum + "";
        this.getUsers(this.projectListRowData.id);
      } else { // 新增
        this.proAddOrEditForm = {
          pid: this.childProjectListRowData
            ? this.childProjectListRowData.id
            : null,
          type: "PROJECT",
          statusNum:'0',
        };
      }
    },
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    userObj() {
      let ret = {};
      this.users.forEach(u => ret[u.id] = u);
      return ret;
    }
  },
  methods: {
    save() {
      this.$refs.proAddOrEditFormRef.validate((valid) => {
        if (valid) {
          if(this.proAddOrEditForm.statusNum){
            if (this.proAddOrEditForm.statusNum === 0 || this.proAddOrEditForm.statusNum === "0") {
              this.proAddOrEditForm.statusName = "未完工";
            } else {
              this.proAddOrEditForm.statusName = "已完工";
            }
          }
          saveProject(this.proAddOrEditForm).then(({ data }) => {
            if (data && data.status === true) {
              ElMessage({
                message: "保存成功",
                type: "success",
              });
              this.visible = false;
              this.$emit("scarch");
            } else {
              ElMessage({
                message: data.msg,
                type: "warning",
              });
            }
          });
        }
      });
    },
    //项目状态选择改变
    statusChange(val) {
      if (val) {
        if (val === 0 || val === "0") {
          this.proAddOrEditForm.statusName = "未完工";
        } else {
          this.proAddOrEditForm.statusName = "已完工";
        }
      }
    },
    getUsers(projectId) {
      getProjectDirectUser({ projectId }).then(({ data }) => {
        this.users = data.data;
      });
    },
    // 项目负责人改变事件
    directorUserChange(userId) {
      let user = this.userObj[userId] || {};
      this.proAddOrEditForm.directorName = user.name;
      this.proAddOrEditForm.directorPhone = user.phone;
    },
    // 项目联系人改变事件
    contactsUserChange(userId) {
      let user = this.userObj[userId] || {};
      this.proAddOrEditForm.contactsName = user.name;
      this.proAddOrEditForm.contactsPhone = user.phone;
    },
    //电子围栏绘制回调
    drawComplete(val){
      this.proAddOrEditForm.electronicFence=val;
      this.innerElectronicDenceDrawer=false;
      //this.save();
      
    }
  },
});
</script>

<style lang="scss" scoped>
</style>

<style lang="scss" >
.pro-drawer {
  .el-drawer__header {
    padding: 0px 10px 0px 10px;
    background: #f7f7f7;
    margin-bottom: 0px;
  }
}
.electronic-fence-drawer{
  .el-drawer__body{
    padding-top: 0px;
  }
}
.electronic-dence-drawer{
  .el-drawer__header{
    padding: 5px 10px 5px 10px;
    background: #d0d0d0;
    margin-bottom: 0px;
  }
  .el-drawer__body{
    padding: 0;
  }
}
</style>